import React, { useEffect } from 'react';
import { Modal, Select, Button, Typography, Space } from 'antd';
import { UserOutlined, WarningOutlined } from '@ant-design/icons';
import { useClientes } from '../../../hooks/useClientes';

const { Text, Title } = Typography;

const ModalClienteObligatorio = ({ 
    isOpen, 
    onClose, 
    setClienteSeleccionado 
}) => {
    const { data: clientes = [] } = useClientes();
    const [clienteTemp, setClienteTemp] = React.useState(null);

    useEffect(() => {
        if (isOpen) setClienteTemp(null);
    }, [isOpen]);

    const handleConfirmar = () => {
        if (!clienteTemp) return;
        
        const clienteObjeto = clientes.find(c => c.id === clienteTemp);
        if (clienteObjeto) {
            setClienteSeleccionado(clienteObjeto);
            onClose(clienteObjeto);
        }
    };

    return (
        <Modal
            open={isOpen}
            onCancel={() => {
                setClienteTemp(null);
                onClose();
            }}
            footer={null}
            centered
            width={450}
            title={
                <Space>
                    <WarningOutlined style={{ color: '#f59e0b', fontSize: '20px' }} />
                    <Title level={4} style={{ margin: 0, fontSize: '18px' }}>
                        Seleccione el cliente para esta venta
                    </Title>
                </Space>
            }
        >
            <div style={{ marginTop: '16px' }}>
                <Text type="secondary" style={{ display: 'block', marginBottom: '16px' }}>
                        Para continuar con la venta es indispensable que selecciones el cliente.
                </Text>

                <Text strong style={{ fontSize: '13px', color: '#475569', display: 'block', marginBottom: '8px' }}>
                    👤 BUSCAR CLIENTE *
                </Text>
                <Select
                    size="large"
                    showSearch
                    placeholder="Buscar por nombre o NIT..."
                    optionFilterProp="label"
                    style={{ width: '100%', borderRadius: '10px', marginBottom: '20px' }}
                    value={clienteTemp}
                    onChange={setClienteTemp}
                    options={clientes.map(c => ({
                        value: c.id,
                        label: `${c.nombre_comercial ? `${c.nombre_comercial} (${c.nombre})` : c.nombre} ${c.documento ? `- ${c.documento}` : ''}`
                    }))}
                />

                <Button
                    type="primary"
                    block
                    size="large"
                    disabled={!clienteTemp}
                    onClick={handleConfirmar}
                    style={{
                        backgroundColor: clienteTemp ? '#22BABB' : '#cbd5e1',
                        borderColor: clienteTemp ? '#22BABB' : '#cbd5e1',
                        height: '48px',
                        borderRadius: '10px',
                        fontWeight: '700',
                        fontSize: '15px'
                    }}
                >
                    CONFIRMAR CLIENTE
                </Button>
            </div>
        </Modal>
    );
};

export default ModalClienteObligatorio;